import { render, staticRenderFns } from "./FinancialPlanning.vue?vue&type=template&id=860e8b54"
import script from "./FinancialPlanning.vue?vue&type=script&lang=js"
export * from "./FinancialPlanning.vue?vue&type=script&lang=js"
import style0 from "./FinancialPlanning.vue?vue&type=style&index=0&id=860e8b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports